import React, { useCallback, useEffect } from 'react';
import { CssBaseline } from '@material-ui/core';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';

import Header from '../Header';
import Footer from '../Footer';
import Snack from '../Snack';
import styled from 'styled-components';

import './index.scss';
import { NotificationListener } from '../NotificationListener/NotificationListener';
import { setScrollPosition, useGetScrollPosition } from '../../services/scrollPosition/scrollPosititonSlice';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

const LayoutWrapper = styled.div`
  display: ${props => (props.isFlexLayout ? 'flex' : 'block')};

  @media (max-width: 1280px) {
    display: block;
  }
`;

const Layout = props => {
  const { children } = props;

  const location = useLocation();

  const isPageWithoutLayout =
    /^\/vehicles\/.*\/(autocheck-report|funding-notice)$/.test(location.pathname) ||
    location.pathname.includes('auction-summary-report/export');

  const isHomePage = location.pathname === '/';
  const isFlexLayout = location.pathname.includes('live-auction');

  const scrollPosition = useGetScrollPosition(location.pathname);

  const dispatch = useDispatch();

  const handleScroll = useCallback(() => {
    dispatch(setScrollPosition({ [location.pathname]: window.scrollY }));
  }, [dispatch, location.pathname]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  useEffect(() => {
    window.scrollTo(0, scrollPosition);
  }, [location.pathname]);

  if (isPageWithoutLayout) {
    return children;
  }

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <CssBaseline />
      <div className="layout-holder">
        <NotificationListener />
        <Header {...props} />
        <LayoutWrapper isFlexLayout={isFlexLayout} className="layout-body">
          {children}
        </LayoutWrapper>
        <Footer noMargin={isHomePage} />
        <Snack {...props} />
      </div>
    </MuiPickersUtilsProvider>
  );
};

export default Layout;
